import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 荣誉榜
 */
import { defineComponent, reactive } from "vue";
import "swiper/css/swiper.css";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import MemberList from "@/components/pc/member-list/member-list.vue";
import lineUrl from "@/assets/img/race-honors/m/line-bottm.png";
// components
export default defineComponent({
  name: "PCHonorSwiperBox",
  props: {
    zone1Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    groupType: {
      type: Object,
      default() {
        return {};
      }
    },
    raceQuarter: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  setup(props) {
    const state = reactive({
      showPreview: false,
      currentIndex: 1,
      ranking: {
        0: "冠军",
        1: "亚军",
        2: "季军"
      }
    });
    function showDetail(index) {
      state.currentIndex = index;
      state.showPreview = true;
    }
    return () => {
      var _props$zone1Teams$, _props$zone1Teams$2, _props$zone1Teams$3;
      return _createVNode("div", {
        "class": "pc-information-honor"
      }, [_createVNode("div", {
        "class": "team-box"
      }, [_createVNode("div", {
        "class": "three-team"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$ = props.zone1Teams[2]) === null || _props$zone1Teams$ === void 0 ? void 0 : _props$zone1Teams$.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "qufu-name"
      }, [props.zone1Teams[2].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "onClick": () => showDetail(2)
      }, null)]), _createVNode("div", {
        "class": "one-team"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$2 = props.zone1Teams[0]) === null || _props$zone1Teams$2 === void 0 ? void 0 : _props$zone1Teams$2.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "qufu-name"
      }, [props.zone1Teams[0].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "onClick": () => showDetail(0)
      }, null)]), _createVNode("div", {
        "class": "two-team"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$3 = props.zone1Teams[1]) === null || _props$zone1Teams$3 === void 0 ? void 0 : _props$zone1Teams$3.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "qufu-name"
      }, [props.zone1Teams[1].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "onClick": () => showDetail(1)
      }, null)])]), _createVNode(PreviewDialog, {
        "visible": state.showPreview,
        "onUpdate:visible": $event => state.showPreview = $event
      }, {
        default: () => [_createVNode("div", {
          "class": "preview-box"
        }, [_createVNode("div", {
          "class": "champion-name-box"
        }, [_createVNode("div", {
          "class": "champion-name-sub"
        }, [_createTextVNode("\u661F\u706B\u8054\u8D5B\u7B2C"), props.raceQuarter.value, _createTextVNode("\u5C4A "), props.groupType.label, " ", state.ranking[state.currentIndex]]), _createVNode("div", {
          "class": "champion-name"
        }, [props.zone1Teams[state.currentIndex].name, _createTextVNode(" \u6218\u961F")])]), _createVNode("div", {
          "class": "member-list-box"
        }, [_createVNode(MemberList, {
          "teamData": props.zone1Teams[state.currentIndex].members,
          "type": "弹窗"
        }, null), _createVNode("img", {
          "src": lineUrl
        }, null)])])]
      })]);
    };
  }
});